import {
  Button,
  Divider,
  Flex,
  Group,
  Modal,
  Text,
  Textarea,
  TextInput,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useCallback } from "react";
import { type SubmitHandler, useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { usePostApi } from "src/hooks";
import { useSelector } from "src/redux/hooks";
import { getYachtId } from "src/utils";
import { Notification } from "src/utils/Notification";

interface IExportForm {
  email: string;
  name: string;
  notes: string;
}

const ExportButton = () => {
  const [opened, { open, close }] = useDisclosure();
  const toExport = useSelector(state => state.searchSlice.toExport);
  const { collectionId } = useParams();
  const { register, handleSubmit } = useForm<IExportForm>();
  const { post, isLoading } = usePostApi();

  const onSubmit: SubmitHandler<IExportForm> = useCallback(
    async data => {
      await post({
        request: "export-entries",
        body: {
          params: {
            yachtid: getYachtId(),
            list: toExport,
            lbid: collectionId,
            ...data,
          },
        },
        onSuccess: () => {
          Notification(
            "Success",
            `This has now been sent to ${data.name}`,
            "green",
          );
          close();
        },
      });
    },
    [close, collectionId, post, toExport],
  );

  return (
    <>
      <Button variant="outline" disabled={toExport.length === 0} onClick={open}>
        Export
      </Button>
      <Modal size="lg" opened={opened} onClose={close} title="Export Entries">
        <Text color="text">
          Entries to export: {toExport.length}. Please enter the email to send
          them to!
        </Text>
        <Divider mt="sm" mb="xl" />
        <form onSubmit={handleSubmit(onSubmit)}>
          <Flex direction="column" mt="xl" gap="sm" w="80%" mx="auto">
            <Flex align="center">
              <Text w="30%" color="text">
                Persons Name:
              </Text>
              <TextInput w="70%" {...register("name", { required: true })} />
            </Flex>
            <Flex align="center" justify="stretch">
              <Text w="30%" color="text">
                Email:
              </Text>
              <TextInput w="70%" {...register("email", { required: true })} />
            </Flex>
            <Flex justify="stretch" direction="column" gap="xs">
              <Text color="text">Medical Notes:</Text>
              <Textarea
                autosize
                minRows={4}
                maxRows={10}
                {...register("notes", { required: true })}
              />
            </Flex>
          </Flex>
          <Group mt="xl" position="right">
            <Button type="submit" loading={isLoading}>
              Export
            </Button>
          </Group>
        </form>
      </Modal>
    </>
  );
};

export default ExportButton;
